<header
    class="{{
        AccountType.isCtop(userInfo.accountType) ? 'bg-background-light-00' : 'bg-background-light-01'
    }} box-border fixed top-0 w-full max-w-[1440px] mx-auto z-50 border-l border-r border-b border-divider-divider flex items-center justify-between"
>
    <!-- Logos -->
    <div (click)="goHome()" class="pl-6 flex sm:flex-row flex-col sm:items-center items-start gap-2 py-3 cursor-pointer">
        <img *ngIf="AccountType.isCtop(userInfo.accountType)" src="{{ environment.publicUrl }}/assets/icons/logo/c-top.svg" class="h-4.5" />
        <img *ngIf="!AccountType.isCtop(userInfo.accountType)" src="{{ environment.publicUrl }}/assets/icons/logo/we-professionals.svg" class="h-[15px]" />
        <img src="{{ environment.publicUrl }}/assets/icons/logo/by-cosentino.svg" class="h-4.5" />
    </div>

    <div class="flex items-center gap-6 text-sm text-gray-700">
        <!-- Idioma -->
        <div class="relative group">
            <!-- Icono -->
            <div class="hidden sm:flex items-center gap-2 py-3 cursor-pointer border-r border-divider-divider pr-6">
                <img src="{{ environment.publicUrl }}/assets/icons/language.svg" class="h-4.5" />
                <!-- ⬇️ antes: ENGLISH | ahora: label dinámico, en mayúsculas como tenías -->
                <span class="typography-body-m-regular">{{ currentLangLabel }}</span>
                <img src="{{ environment.publicUrl }}/assets/icons/expand-more.svg" alt="arrow" class="w-6" />
            </div>

            <!-- Popup -->
            <!-- (opcional) si tendrás muchos idiomas, añade `overflow-auto` para que haga scroll -->
            <div
                class="absolute right-0 w-[200px] h-[300px] bg-white z-50 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none group-hover:pointer-events-auto overflow-auto"
            >
                <div class="px-6 py-2 text-center">
                    <div class="flex flex-col gap-2">
                        <!-- ⬇️ antes: dos divs fijos; ahora: lista desde WE_LOCALES -->
                        <div
                            class="typography-body-m-regular cursor-pointer"
                            *ngFor="let lang of languages"
                            (click)="changeLang(lang.code)"
                            [class.font-semibold]="isActive(lang.code)"
                        >
                            {{ lang.label }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Notificaciones -->
        <div class="relative group">
            <!-- Icono -->
            <div class="cursor-pointer border-r border-divider-divider pr-6 py-3">
                <div class="relative">
                    <img src="{{ environment.publicUrl }}/assets/icons/notifications.svg" alt="bell" class="size-6" />
                    <span class="absolute -top-1 -right-1 bg-black text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center">0</span>
                </div>
            </div>

            <!-- Popup -->
            <div class="absolute right-0 w-[400px] bg-white z-50 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none group-hover:pointer-events-auto">
                <div class="px-6 py-8 text-center">
                    <div class="typography-title-s font-light">NOTIFICACIONES</div>
                    <div class="mt-3 typography-body-s-light">No tienes notificaciones pendientes</div>

                    <!-- Icono campana punteada -->
                    <div class="mt-8 flex justify-center mb-6">
                        <img src="{{ environment.publicUrl }}/assets/icons/no-notifications.svg" class="w-32" />
                    </div>

                    <hr class="mb-5" />

                    <button class="mx-auto cosentino-button ctop L primary cursor-pointer">
                        <div><span class="typography-body-m-medium oneLine">Mark all as read</span></div>
                    </button>
                </div>
            </div>
        </div>

        <!-- Perfil -->
        <div (click)="onToggleMobileMenu.emit()" class="block md:hidden relative pr-6 cursor-pointer">
            <app-cosentino-svg *ngIf="isMobileMenuOpen" svgName="close" [size]="24" />
            <app-cosentino-svg *ngIf="!isMobileMenuOpen" svgName="hamburger" [size]="24" />
        </div>
        <div class="hidden md:block relative">
            <!-- Icono -->
            <div (click)="toggleProfilePopup()" class="pr-6 flex items-center gap-2 py-3 z-50 cursor-pointer">
                <img src="{{ environment.publicUrl }}/assets/icons/profile.svg" alt="user" class="size-6" />
                <span class="typography-body-m-regular">{{ 'my-profile' | translate }}</span>
                <img src="{{ environment.publicUrl }}/assets/icons/expand-more.svg" alt="arrow" class="w-6" />
            </div>

            <!-- Popup -->
            <div *ngIf="isProfilePopupOpen" class="full-overlay" (click)="toggleProfilePopup()"></div>
            <div style="z-index: 400" class="{{ isProfilePopupOpen ? '' : 'hidden' }} absolute right-0 w-[300px] bg-white transition-opacity">
                <div class="py-6 px-4">
                    <div class="flex flex-col">
                        <div class="flex-col flex">
                            <app-button [ghost]="true" (onClick)="goToProfile()">
                            <div class="flex flex-row gap-2">
                                <div>
                                    <img src="{{ environment.publicUrl }}/assets/icons/profile.svg" alt="user" class="size-4" />
                                </div>
                                <div class="typography-body-m-regular text-text-secondary">{{ 'profile.setup-my-profile' | translate }}</div>
                            </div>
                            </app-button>
                        </div>
                        <div class="divider mt-3"></div>
                        <div class="p-4 flex-col flex ">
                            <span class="typography-body-l-medium text-text-secondary">{{ 'home.your_commercial_contact' |translate }}</span
                            >
                            <span class="typography-body-l-regular mb-3">{{ userInfo.accountOwnerFullName }}</span>

                            <span class="typography-body-l-medium text-text-secondary">{{ 'my_profile.email_label' | translate }}</span>
                            <span>{{ userInfo.accountOwnerEmail }}</span>
                        </div>
                        <div *ngIf="userInfo.role == 'ADMIN'" class="background-light-00 p-4 mt-4 mb-2 flex flex-col">
                            <div class="flex-row flex gap-2 justify-between">
                            <div class="flex flex-col">
                                {{ 'home.authorize_assistance' | translate }}
                                <div class="flex flex-row items-center text-primary-default typography-body-s-light gap-2">
                                    <img
                                        src="assets/icons/chevron-down.svg"
                                        style="width: 16px; height: 16px; cursor: pointer"
                                        [class.rotate-180]="showDisclaimer"
                                        (click)="showDisclaimer = !showDisclaimer"
                                        alt="Toggle"
                                    />
                                    <span class="text-primary-default typography-body-s-regular">{{ 'global.view_more' | translate }}</span>
                                </div>
                                
                            </div>
                            <app-checkbox-toggle [isChecked]="allowAccountAccess || false" (onChecked)="onAllowAccessChange(!allowAccountAccess)"></app-checkbox-toggle>
                            </div>
                            
                            <span [ngStyle]="{ display: showDisclaimer ? 'block' : 'none' }" class="typography-body-s-light">{{ 'home.authorize_assistance_disclaimer' | translate }}</span>

                            
                        </div>

                        <div class="divider my-3"></div>
                        <app-button [ghost]="true">
                            <div class="flex flex-row text-primary-default items-center gap-2">
                                <app-cosentino-svg class="icon" [svgName]="'log-out'" [size]="24"></app-cosentino-svg>
                                <span class="typography-body-l-medium" (click)="logout()">{{ 'home.logout' | translate }}</span>
                            </div>
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
